<template>
    <div class="grado-grupo-form">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" width="400">
                    <v-card>
                        <v-toolbar card prominent color="primary" dark>
                            <v-toolbar-title class="body-2">{{ this.formTitle }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="cancelForm()">
                                <v-icon medium>fa-close</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-card-text>
                            <v-form ref="gradoGrupoForm" v-model="validGradoGrupo">
                                <v-container fluid grid-list-xl>
                                    <v-layout align-center wrap>
                                        <v-flex xs12 sm12>
                                            <v-select
                                                v-model="gradoGrupoItem.grado"
                                                :items="GRADOS"
                                                label="Grado*"
                                                item-text="nombre"
                                                item-value="id"
                                                :rules="gradoRules"
                                                :error-messages="gradoErrors"
                                                @change="gradoErrors = []"
                                                append-outer-icon="add"
                                                @click:append-outer="showGradoForm = true"
                                                return-object
                                            >
                                            </v-select>
                                        </v-flex>
                                        <v-flex xs12 sm12>
                                            <v-text-field
                                                v-model="gradoGrupoItem.nombre_grupo"
                                                label="Nombre grupo*"
                                                :rules="nombreGrupoRules"
                                                :error-messages="nombreGrupoErrors"
                                                @change="nombreGrupoErrors = []"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm12>
                                            <v-autocomplete
                                                v-model="gradoGrupoItem.profesor_grupo"
                                                label="Profesor"
                                                :rules="profesorGrupoRules"
                                                :error-messages="profesorGrupoErrors"
                                                @change="profesorGrupoErrors = []"
                                                :items="EMPLEADOS"
                                                item-text="nombre"
                                                item-value="id"
                                                :filter="customFilter"
                                                hide-selected
                                            >
                                                <template v-slot:item="data">
                                                    <v-list-tile-content>
                                                        <v-list-tile-title
                                                            v-html="
                                                                data.item.nombre +
                                                                    ' ' +
                                                                    data.item.apellido_paterno +
                                                                    ' ' +
                                                                    data.item.apellido_materno
                                                            "
                                                        >
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </template>
                                                <template v-slot:selection="data">
                                                    {{
                                                        data.item.nombre +
                                                            " " +
                                                            data.item.apellido_paterno +
                                                            " " +
                                                            data.item.apellido_materno
                                                    }}
                                                </template>
                                                <template slot="no-data">
                                                    <div style="text-align: center">
                                                        No existen profesores registrados en el sistema.
                                                    </div>
                                                </template>
                                            </v-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Cancelar</v-btn>
                            <v-btn
                                color="success"
                                flat
                                @click="saveForm()"
                                :disabled="disableSaveButton"
                                :loading="loading"
                                >Guardar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>

        <grado-form
            v-if="showGradoForm"
            form-title="Nuevo grado"
            :initial-item="null"
            @formCanceled="showGradoForm = false"
        >
        </grado-form>
    </div>
</template>

<script>
const GradoForm = () => import("@/components/cobranza/nomencladores/grado-form/grado-form")
import { mapGetters } from "vuex"
export default {
    components: { GradoForm },
    props: {
        formTitle: { type: String, default: null },
        initialItem: { type: Object, default: null }
    },
    data() {
        return {
            loading: false,
            validGradoGrupo: false,
            gradoGrupoItem: {
                grado: "",
                nombre_grupo: "",
                profesor_grupo: ""
            },
            gradoRules: [v => !!v || "Debe proporcionar el grado"],
            gradoErrors: [],
            nombreGrupoRules: [v => !!v || "Debe proporcionar el nombre del grupo"],
            nombreGrupoErrors: [],
            profesorGrupoRules: [v => !!v || "Debe proporcionar el nombre del profesor del grupo"],
            profesorGrupoErrors: [],

            //nomencladores
            showGradoForm: false
        }
    },
    computed: {
        ...mapGetters(["GRADOS", "EMPLEADOS"]),

        isNewRecord() {
            return this.initialItem === null
        },

        showForm: {
            get: function() {
                return true
            },
            set: function() {
                return this.cancelForm()
            }
        },

        disableSaveButton() {
            return this.loading || !this.validGradoGrupo
        }
    },

    methods: {
        saveForm() {
            this.loading = true
            this.$refs.gradoGrupoForm.validate()
            if (this.validGradoGrupo) {
                var grupo = {
                    campus_id: this.gradoGrupoItem.grado.campus_id,
                    seccion_id: this.gradoGrupoItem.grado.seccion_id,
                    grado_id: this.gradoGrupoItem.grado.id,
                    letra: this.gradoGrupoItem.nombre_grupo,
                    empleado_id: this.gradoGrupoItem.profesor_grupo
                }

                this.$store.dispatch("ADD_GRUPO", grupo).then(result => {
                    if (!result) {
                        //no hay coneccion con el servidor
                        this.loading = false
                    }
                    if (result === null || result.status === 404) {
                        //cerrar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe
                        this.$emit("formCanceled")
                    } else {
                        // El backend devolvió error de validación, pasando los errores a los campos correspondientes
                        let { data, status } = result
                        if (status === 422) {
                            data.forEach(error => {
                                if (
                                    error.field === "campus_id" ||
                                    error.field === "seccion_id" ||
                                    error.field === "grado_id"
                                ) {
                                    this.gradoErrors.push(error.message)
                                }
                                if (error.field === "letra") {
                                    this.nombreGrupoErrors.push(error.message)
                                }
                                if (error.field === "empleado_id") {
                                    this.profesorGrupoErrors.push(error.message)
                                }
                            })
                        }
                    }
                    this.loading = false
                })
            } else {
                this.loading = false
            }
        },

        cancelForm() {
            this.$emit("formCanceled")
        },

        customFilter(item, queryText) {
            const textNombre = item.nombre.toLowerCase()
            const textApellidoPaterno = item.apellido_paterno.toLowerCase()
            const textApellidoMaterno = item.apellido_materno.toLowerCase()
            const searchText = queryText.toLowerCase()

            return (
                textNombre.indexOf(searchText) > -1 ||
                textApellidoPaterno.indexOf(searchText) > -1 ||
                textApellidoMaterno.indexOf(searchText) > -1
            )
        }
    },

    created() {
        this.$store.dispatch("LOAD_ALL_GRADOS")
        this.$store.dispatch("LOAD_ALL_EMPLEADOS")
    }
}
</script>

<style scoped></style>
